import { useQuery } from '@tanstack/react-query';
import { fetchDistricts } from '../../../api/administration/demographics/locations';

export const useDistricts = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['districts', filters],
    queryFn: () => {
      const params = { ...filters };
      if (params?.pageSize && !params.limit) {
        params.limit = params.pageSize;
      }
      return fetchDistricts(params);
    },
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.districts ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useDistricts;
